/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Category_TitleInputs */

const vi_shop_category_title = /** @type {(inputs: Shop_Category_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh mục bán`)
};

/**

* @param {Shop_Category_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_category_title = /** @type {((inputs?: Shop_Category_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Category_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_category_title(inputs)
});